/** @format */

import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { FormikProps } from "formik";
import * as React from "react";
import { useAppSelector } from "../../app/hooks";
import { selectApplicant } from "../../features/applicant/ApplicantSlice";
import { ApplicantViewDto, LegalGuardianDetailDto } from "../../features/applicant/Models";
import { ErrorBox } from "../custom/ErrorBox";

interface Props {
  formik: FormikProps<any>;

}
export default function ApplicantGuardians({ formik }: Props) {
  const selectApplicantData = useAppSelector(selectApplicant);
  const [data, setData] = React.useState<ApplicantViewDto>();

  React.useEffect(() => {
    if (selectApplicantData.applicantState.applicant) {
      setData(selectApplicantData.applicantState.applicant);
    }
  }, [selectApplicantData.applicantState.applicant]);

  return (
    <>
      {data && data.guardians && (
        <>
          <FormControl fullWidth>
            <InputLabel
              error={
                formik.touched.guardianId &&
                Boolean(formik.errors.guardianId)
              }
              id="demo-select-small"
            >
             Select Guardian
            </InputLabel>
            <Select
              required
              name="guardianId"
              labelId="demo-select-small"
              id="demo-select-small"
              value={formik.values.guardianId}
              label="Select Guardian"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              error={
                formik.touched.guardianId &&
                Boolean(formik.errors.guardianId)
              }
            >
              <MenuItem value={-1} disabled>
              Select Guardian
              </MenuItem>
              {data.guardians.map(
                (data: LegalGuardianDetailDto, key: number) => {
                  return (
                    <MenuItem key={key} value={data.id}>
                      {`${data.firstName} ${data.surname}`}
                    </MenuItem>
                  );
                }
              )}
            </Select>
          </FormControl>

<ErrorBox>
{formik.touched.guardianId &&
              (formik.errors.guardianId as React.ReactNode)}
</ErrorBox>
         
        </>
      )}
    </>
  );
}
